// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconLinearSecurityUser = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      xmlns: 'http://www.w3.org/2000/svg',
      width: '24',
      height: '24',
      viewBox: '0 0 16 17',
      fill: 'none',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M6.99343 1.98703L3.66677 3.23369C2.9001 3.52036 2.27344 4.42702 2.27344 5.24702V10.2003C2.27344 10.987 2.79344 12.0204 3.42678 12.4937L6.29344 14.6337C7.23344 15.3404 8.78009 15.3404 9.72009 14.6337L12.5868 12.4937C13.2201 12.0204 13.7401 10.987 13.7401 10.2003V5.24702C13.7401 4.42702 13.1134 3.52036 12.3468 3.23369L9.0201 1.98703C8.45343 1.78036 7.54676 1.78036 6.99343 1.98703Z',
      stroke: 'currentColor',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7.99996 7.78027C7.97329 7.78027 7.93996 7.78027 7.91329 7.78027C7.28662 7.76027 6.78662 7.24027 6.78662 6.60693C6.78662 5.96027 7.31329 5.43359 7.95996 5.43359C8.60663 5.43359 9.1333 5.96027 9.1333 6.60693C9.12663 7.24693 8.62663 7.76027 7.99996 7.78027Z',
      stroke: 'currentColor',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M6.67336 9.6482C6.03336 10.0749 6.03336 10.7749 6.67336 11.2015C7.40003 11.6882 8.59336 11.6882 9.32003 11.2015C9.96003 10.7749 9.96003 10.0749 9.32003 9.6482C8.60003 9.16154 7.40669 9.16154 6.67336 9.6482Z',
      stroke: 'currentColor',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    }),
  );

export { IconLinearSecurityUser };
